import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBPO_rkO7kx80jHLqUHDh8ksj1RTRfOU2Q",
  authDomain: "metaverse-9715e.firebaseapp.com",
  projectId: "metaverse-9715e",
  storageBucket: "metaverse-9715e.appspot.com",
  messagingSenderId: "921347069868",
  appId: "1:921347069868:web:23f26e76a588fa4d248c09",
  measurementId: "G-BLJRPKJ5CK",
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

export { app, analytics, db, storage, auth };
